import { Component } from 'react';

import ReCaptcha from '../../../components/ui/recaptcha/recaptcha.component';
import { IOC_TYPES } from '../../../context/ioc.types';
import { lazyInject } from '../../../context/module';
import { BasicValidators, FormControl, FormGroup } from '../../../models/forms';
import { LoginService } from '../../../services/login.service';
import { ScriptLoadService } from '../../../services/script-load.service';
import { SpinnerService } from '../../../services/spinner.service';
import { UIContext } from '../../../services/ui-context';
import { WindowService } from '../../../services/window.service';
import { UrlUtils } from '../../../utils/url.utils';

export default class PasswordResetPageComponent extends Component {
    formGroup: FormGroup;
    isBrowser;

    @lazyInject(ScriptLoadService) private scriptLoaderService: ScriptLoadService;
    @lazyInject(LoginService) private loginService: LoginService;
    @lazyInject(UIContext) private uiContext: UIContext;
    @lazyInject(SpinnerService) private spinnerService: SpinnerService;
    @lazyInject(WindowService) private windowService: WindowService;

    constructor(props) {
        super(props);
        this.formGroup = new FormGroup({
            email: new FormControl('', { required: BasicValidators.required }),
            password: new FormControl('', { required: BasicValidators.required }),
            token: new FormControl('', { required: BasicValidators.required }),
            k: new FormControl(UrlUtils.getUrlParameter('k'),),
        });
    }

    componentDidMount() {
        this.windowService.userEngaged.subscribe({
            next: async () => {
                await this.scriptLoaderService.loadAllScriptsIfNotLoaded();
            }
        });
    }

    async submit() {
        if (this.formGroup.valid) {
            const value = this.formGroup.value;
            this.spinnerService.runWithLoader(() => {
                return this.loginService.resetPassword(value.email, value.password, value.token, value.k)
                    .toPromise().then(
                        (data) => {
                            this.uiContext.showSuccessDialog('Success', 'Please login to user account!');
                            setTimeout(() => location.href = 'portal', 3000);
                        },
                        err => this.uiContext.handleError(err),
                    );
            });
        } else {
            this.uiContext.showErrorDialog({ title: 'Error', text: 'Invalid information!' });
        }
    }

    // handleCorrectCaptcha(event) {
    //     this.formGroup.get('token').setValue(event);
    // }

    setReCaptchaValue(e) {
        this.formGroup.controls['token'].setValue(e);
    }

    render() {
        // Real <form>: password-manager save/update heuristics + Enter-to-submit
        // (handler on onSubmit only — see login.component note).
        return <div className="row">
            <form className="col-sm-12 mt-3 mb-3" method="post"
                onSubmit={(e) => { e.preventDefault(); this.submit(); }}>
                <div className="form-group mb-3">
                    <label htmlFor="email">E-mail: </label>
                    <input type="email" name="email" autoComplete="email" className="form-control" id="email" aria-describedby="emailHelp"
                        onInput={(e: any) => this.formGroup.controls['email'].setValue(e.target.value)} />
                </div>
                <div className="form-group mb-3">
                    <label htmlFor="password">New password: </label>
                    <input type="password" name="new-password" autoComplete="new-password" className="form-control" id="password"
                        onInput={(e: any) => this.formGroup.controls['password'].setValue(e.target.value)}
                    />
                </div>
                <div className="mt-3 mb-3">
                    <label>Verification</label>
                    <ReCaptcha onChange={e => this.setReCaptchaValue(e)}></ReCaptcha>
                </div>
                <button type="submit" className="btn btn-primary"
                >Submit</button>
            </form>
        </div>
    }
}
